/**
 * Created by quikr on 1/5/17.
 */
import React, {PropTypes} from "react";
import {connect} from "react-redux";
import Navigation from "../../components/common/Navigation";
import LinearProgress from "material-ui/LinearProgress";
import Banner from "../../components/common/Banner";
import {hashHistory} from "react-router";
import toastr from "toastr";
import axios from "axios";


function convert(node) {
  node.oD = node.offerDate;
  node.jD = node.joiningDate;
  node.eD = node.empDob;

  node.offerDate = node.offerDate ? new Date(node.offerDate) : null;
  node.joiningDate = node.joiningDate ? new Date(node.joiningDate) : null;
  node.empDob = node.empDob ? new Date(node.empDob) : null;
  return node;
}


class RecruiterHome extends React.Component {

  constructor(props) {
    super();
    this.state = {options: props.options, employees: [], loading: 1, initialValues: {}, joiners: []};
    this.refresh = this.refresh.bind(this);
    this.edit = this.edit.bind(this);
    this.submitNew = this.submitNew.bind(this);
    this.submitEdit = this.submitEdit.bind(this);
    this.refreshEdit = this.refreshEdit.bind(this);
    this.changeBanner = this.changeBanner.bind(this);
  }


  remove(empId) {
  }

  submitNew(data) {
    // data.name=data.firstName+" "+data.lastName;

    return new Promise((resolve, reject)=> {
      let requestObject = new Object();
      Object.assign(requestObject, data);
      if (requestObject.firstName == undefined || requestObject.lastName == undefined) {
        reject(false);
        toastr.error("Error Occurred");
        return;
      }
      requestObject.name = requestObject.firstName + " " + requestObject.lastName;
      requestObject.offerStatus = 'Offer Made';
      requestObject.recruiter = this.props.recruiter.empno + " " + this.props.recruiter.name;
      if (requestObject.gender == null)
        reject(false);


      axios.post(process.env.REQ_URL + "/onBoarding/saveJoiner", {data: requestObject}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        toastr.success("New Joiner Added");
        this.refresh();
        hashHistory.push("/1/recruiter/onBoarding");
        resolve(true);
      }).catch((error)=> {
        reject(false);
        toastr.error("Error Occurred");
      })
    })

  }

  submitEdit(data) {
    return new Promise((resolve, reject)=> {
      let requestObject = new Object();
      Object.assign(requestObject, data);
      requestObject.name = requestObject.firstName + " " + requestObject.lastName;

      axios.post(process.env.REQ_URL + "/onBoarding/saveJoiner", {data: requestObject}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {

        toastr.success("Saved");
        resolve("success");
        // this.refreshEdit(requestObject.id);


      }).catch((error)=> {
        reject("fail");
        console.log(error);
      });
    })

  }

  refreshEdit(id) {
    axios.get(process.env.REQ_URL + "/onBoarding/getJoinerById?q=" + id, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      response.data.data = convert(response.data.data);
      if (response.data.data.name != null) {
        response.data.data.firstName = response.data.data.name.split(' ')[0];
        response.data.data.lastName = response.data.data.name.split(' ')[1];
      }
      this.setState({initialValues: {initialValues: response.data.data}});
    }).catch((error)=> {
      console.log(error);

    })
  }

  edit(id) {
    axios.get(process.env.REQ_URL + "/onBoarding/getJoinerById?q=" + id, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      response.data.data = convert(response.data.data);
      if (response.data.data.name != null) {
        response.data.data.firstName = response.data.data.name.split(' ')[0];
        response.data.data.lastName = response.data.data.name.split(' ')[1];
      }
      this.setState({initialValues: {initialValues: response.data.data}});
      hashHistory.push("/1/recruiter/edit/" + id);

    }).catch((error)=> {
      console.log(error);

    })
  }

  refresh() {
    axios.get(process.env.REQ_URL + "/onBoarding/getJoinersByRecruiter", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      console.log(response.data.data);
      response = response.data.data.map((node)=> {
        return convert(node);
      });
      console.log(response);
      this.setState({joiners: response});

    }).catch((error)=> {

    })
  }


  componentDidMount() {
    axios.get(process.env.REQ_URL + "/onBoarding/getJoinersByRecruiter", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      console.log(response.data.data);
      response = response.data.data.map((node)=> {
        return convert(node);
      });
      this.setState({joiners: response});
    }).catch((error)=> {

    });

  }

  changeBanner(name) {
    this.setState({banner: name});
  }

  render() {
    console.log(this.props.params);
    return (
      <div>
        <Banner name={this.state.banner}/>
        <div className="container" style={{marginLeft: '10', marginRight: '10', width: '100%'}}>
          <div className="wrapper-1">
            <div className="row clearfix">
              <div className="col-xs-12">
                <div id="tab_content">
                  <Navigation options={this.state.options}/>
                  <div className="tab-content responsive" style={{padding: 0}}>
                    <div role="tabpanel" className="tab-panel">
                      <div className="row clearfix">
                        {this.state.loading == 0 ?
                          <LinearProgress mode="indeterminate" style={{padding: '2px', width: '100%'}}/> :
                          <label></label> }
                        <div className="inner-col-wrap inner-table-wrap ">
                          {React.cloneElement(this.props.children, {
                            edit: this.edit,
                            recruiter: this.props.recruiter,
                            refresh: this.refresh,
                            initialValues: this.state.initialValues,
                            submitNew: this.submitNew,
                            submitEdit: this.submitEdit,
                            changeBanner: this.changeBanner,
                            employees: this.state.employees,
                            activeEmployees: this.props.activeEmployees,
                            constants: this.props.constants,
                            joiners: this.state.joiners,
                            remove: this.remove
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


RecruiterHome.defaultProps = {
  options: [
    {
      text: "On-Boarding",
      active: true,
      url: "#/1/recruiter/onBoarding",
      url2: "#/1/recruiter"
    },
    {
      text: "Add New",
      active: true,
      url: "#/1/recruiter/add",

    }
  ]
};
RecruiterHome.propTypes = {
  options: React.PropTypes.array
};

function mapStateToProps(state, ownState) {
  return {
    recruiter: state.emp[0],
    activeEmployees: state.employees,
    constants: state.constants
  };

}


export default connect(mapStateToProps)(RecruiterHome);





/** WEBPACK FOOTER **
 ** ./src/feature/onboarding/RecruiterHome.js
 **/